import type { EmailActivity } from '@common/types/activities';
import { Box, Link, Typography } from '@mui/material';
import ShowLessButton from '../ShowLessButton';
import { cleanHTML } from '../util';

interface Props {
    emailBody: EmailActivity['body'];
    isBodyExpanded: boolean;
    setIsBodyExpanded: (val: boolean) => void;
}

export default function IntakeReminderBody({
    emailBody,
    isBodyExpanded,
    setIsBodyExpanded,
}: Props) {
    return (
        <>
            {emailBody.IntakeEmailIntroduction ? (
                <Box
                    sx={{
                        marginTop: '16px',
                        wordWrap: 'break-word',
                        overflowWrap: 'anywhere',
                    }}
                >
                    <Typography
                        variant="h4"
                        sx={{
                            marginBottom: '16px',
                        }}
                    >
                        Intake email reminder
                    </Typography>
                    <Typography variant="body2" color="text.primary">
                        Hello {emailBody?.ClientName},
                    </Typography>
                    <Typography variant="body2" color="text.primary">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: cleanHTML(emailBody?.IntakeEmailIntroduction || ''),
                            }}
                        ></div>
                    </Typography>
                    <Link
                        sx={{
                            textDecoration: 'none',
                            fontSize: '14px',
                            lineHeight: '16px',
                            fontWeight: '500',
                            marginTop: '16px',
                            display: 'block',
                            cursor: 'pointer',
                        }}
                        href={emailBody?.IntakeFormLink}
                    >
                        Intake form link
                    </Link>
                    <Typography variant="body2" sx={{ color: 'text.primary', marginTop: '16px' }}>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: cleanHTML(emailBody?.IntakeEmailClosing || ''),
                            }}
                        ></div>
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.primary', marginTop: '16px' }}>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: cleanHTML(emailBody?.EmailSignature || ''),
                            }}
                        ></div>
                    </Typography>
                    <ShowLessButton
                        isBodyExpanded={isBodyExpanded}
                        bodyExpandedHandler={setIsBodyExpanded}
                    />
                </Box>
            ) : (
                <ShowLessButton
                    isBodyExpanded={isBodyExpanded}
                    bodyExpandedHandler={setIsBodyExpanded}
                />
            )}
        </>
    );
}
